import { ApiError, defaultHttpClient } from '../../httpClient';
import type { MarketDetail } from './types';

export const getMarketDetail = (marketId: number) => {
  return defaultHttpClient
    .request<MarketDetail>({
      method: 'GET',
      url: `/api/v2/markets/${marketId}/`,
    })
    .then(result => result.data)
    .then(result => {
      if (result.market.accepted_at === null) {
        throw new ApiError({
          message: '존재하지 않는 페이지입니다',
          status: 404,
        });
      }
      return result;
    });
};
